module.exports = __webpack_public_path__ + "static/media/bpi_wealth.8cdb6b43.png";